// Import model
import { StartObjectAppointmentSendAppointmentConfirmationEmailRequest } from '../models/StartObjectAppointmentSendAppointmentConfirmationEmailRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartObjectAppointmentSendAppointmentConfirmationEmailRequest - handles JSON serialization and deserialization with type validation
 */
export class StartObjectAppointmentSendAppointmentConfirmationEmailRequestSerializer {
  /**
   * Deserializes a JSON string into a StartObjectAppointmentSendAppointmentConfirmationEmailRequest instance
   */
  static deserialize(json: string): StartObjectAppointmentSendAppointmentConfirmationEmailRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartObjectAppointmentSendAppointmentConfirmationEmailRequest instance
   */
  static fromObject(obj: any): StartObjectAppointmentSendAppointmentConfirmationEmailRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartObjectAppointmentSendAppointmentConfirmationEmailRequest');
    }


    const instance: StartObjectAppointmentSendAppointmentConfirmationEmailRequest = {
      description: obj['Description'] as string | undefined,
      unlayerTemplateId: obj['UnlayerTemplateId'] as string | undefined,
      message: obj['Message'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartObjectAppointmentSendAppointmentConfirmationEmailRequest instances
   */
  static deserializeArray(json: string): StartObjectAppointmentSendAppointmentConfirmationEmailRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartObjectAppointmentSendAppointmentConfirmationEmailRequest instance to a JSON string
   */
  static serialize(instance: StartObjectAppointmentSendAppointmentConfirmationEmailRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartObjectAppointmentSendAppointmentConfirmationEmailRequest instance to a plain object
   */
  static toObject(instance: StartObjectAppointmentSendAppointmentConfirmationEmailRequest): any {
    return {
      'Description': instance.description,
      'UnlayerTemplateId': instance.unlayerTemplateId,
      'Message': instance.message,
    };
  }

  /**
   * Serializes an array of StartObjectAppointmentSendAppointmentConfirmationEmailRequest instances to a JSON string
   */
  static serializeArray(instances: StartObjectAppointmentSendAppointmentConfirmationEmailRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
